import React, { useEffect, useState } from 'react';
import {
  Layout,
  Link,
  Space,
  Grid,
  Image,
  Typography,
} from '@arco-design/web-react';
import { FooterProps } from '@arco-design/web-react/es/Layout/interface';
import cs from 'classnames';
import styles from './style/index.module.less';
import request from '@/request/request';
const { Row, Col } = Grid;

function Footer(props: FooterProps = {}) {
  const { className, ...restProps } = props;
  // 获取当前年份
  return (
    <Layout.Footer className={cs(className)} {...restProps}>
      <Space
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '40px',
          textAlign: 'center',
          color: 'var(--color-text-2)',
        }}
      >
        <span>© 版权所有 2023-{new Date().getFullYear()}</span>
        <span>
          <Link target="_blank" href="https://beian.miit.gov.cn">
            蜀ICP备2024055643号-2
          </Link>
        </span>
      </Space>
    </Layout.Footer>
  );
}

export default Footer;
